module.exports = __webpack_public_path__ + "img/logo_kibon.3a567380.png";